import { DefaultQueryParams } from './defaultQueryParams';
import { parseQuery } from '../helpers/parseQuery';

const { [DefaultQueryParams.PartnerId]: partnerId } = parseQuery(window.location.search);

export const PartnerIds = {
  iChancy: 999,
};

export const isIChancy = () => {
  return +partnerId === PartnerIds.iChancy;
};
